import { render } from "./basicInfo.vue?vue&type=template&id=14e7c208&scoped=true&ts=true&lang=pug"
import script from "./basicInfo.vue?vue&type=script&lang=ts"
export * from "./basicInfo.vue?vue&type=script&lang=ts"

import "./basicInfo.vue?vue&type=style&index=0&id=14e7c208&lang=stylus&scoped=true"

import exportComponent from "/builds/findsoft/hero/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14e7c208"]])

export default __exports__